import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

/**
 * Open an external URL, handling native (Capacitor) and web contexts.
 * On native, `window.open` is a no-op — use the system in-app browser.
 */
export async function openExternalUrl(url: string): Promise<void> {
  if (Capacitor.isNativePlatform()) {
    await Browser.open({ url, presentationStyle: 'popover' });
    return;
  }
  const win = window.open(url, '_blank', 'noopener,noreferrer');
  if (!win) {
    window.location.assign(url);
  }
}
